export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/opt/buildhome/repo/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/opt/buildhome/repo/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/admin-users',
    name: '/admin-users',
    component: () => import('/opt/buildhome/repo/src/pages/admin-users.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/apps',
    /* internal name: '/apps' */
    /* no component */
    children: [
      {
        path: '',
        name: '/apps/',
        component: () => import('/opt/buildhome/repo/src/pages/apps/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: ':id',
        name: '/apps/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/apps/[id].vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/avatar-applies',
    name: '/avatar-applies',
    component: () => import('/opt/buildhome/repo/src/pages/avatar-applies.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/billing-plans',
    name: '/billing-plans',
    component: () => import('/opt/buildhome/repo/src/pages/billing-plans.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/configs',
    name: '/configs',
    component: () => import('/opt/buildhome/repo/src/pages/configs.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/credit-packages',
    name: '/credit-packages',
    component: () => import('/opt/buildhome/repo/src/pages/credit-packages.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/credit-transactions',
    name: '/credit-transactions',
    component: () => import('/opt/buildhome/repo/src/pages/credit-transactions.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/driven-stats',
    /* internal name: '/driven-stats' */
    /* no component */
    children: [
      {
        path: '',
        name: '/driven-stats/',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: 'overview',
        name: '/driven-stats/overview',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/overview.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: 'ranking',
        name: '/driven-stats/ranking',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/ranking.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: 'realtime',
        name: '/driven-stats/realtime',
        component: () => import('/opt/buildhome/repo/src/pages/driven-stats/realtime.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/feedback',
    /* internal name: '/feedback' */
    /* no component */
    children: [
      {
        path: '',
        name: '/feedback/',
        component: () => import('/opt/buildhome/repo/src/pages/feedback/index.vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      },
      {
        path: ':id',
        name: '/feedback/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/feedback/[id].vue'),
        /* no children */
        meta: {
          "layout": "default"
        },
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/opt/buildhome/repo/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "auth",
      "public": true
    },
  },
  {
    path: '/public-avatars',
    name: '/public-avatars',
    component: () => import('/opt/buildhome/repo/src/pages/public-avatars.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/user-characters',
    name: '/user-characters',
    component: () => import('/opt/buildhome/repo/src/pages/user-characters.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/user-configs',
    name: '/user-configs',
    component: () => import('/opt/buildhome/repo/src/pages/user-configs.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/users',
    name: '/users',
    component: () => import('/opt/buildhome/repo/src/pages/users.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

